import { TranslationService } from 'app/services/translation.service';
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'TranslationPipe'
})
export class TranslationPipe implements PipeTransform {
  
  constructor(private translationService: TranslationService){}
  transform(variableName: string, placeholderValues: string[] = []): string {
    return this.translationService.getTranslation(variableName, placeholderValues)
  }
}



// WEBPACK FOOTER //
// C:/Projects/ePlanner Maintenance/src/app/pipes/TranslationPipe.ts